import styled from '@emotion/styled';
import { useTheme } from '@mui/material';
import { PageTemplate } from '@components/template';
import { Loading48Icon } from '@icons/LoadingIcon';

/**
 * OAuth/SSO 콜백 처리 중 로딩 화면
 */
export const OAuthProcessingView = () => {
  const theme = useTheme();

  return (
    <PageTemplate>
      <LoadingContainer>
        <Loading48Icon color={theme.colors['bg-primary']} />
      </LoadingContainer>
    </PageTemplate>
  );
};

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 70px - var(--employee-gnb-height));
  height: 100%;
`;
